export { ExamesSolicitadosDoSetor } from './ExamesSolicitadosDoSetor'
